import { useTranslation } from 'react-i18next';

const FEATURES = [
  { key: 's1.f1', icon: 'ri-draft-line' },
  { key: 's1.f2', icon: 'ri-vip-diamond-line' },
  { key: 's1.f3', icon: 'ri-shield-star-line' },
];

export default function IntroSection() {
  const { t } = useTranslation();

  return (
    <section id="garaj" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <div className="reveal flex flex-col justify-center">
          <span className="mb-5 h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('s1.title')}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {t('s1.text')}
          </p>
        </div>

        <div className="reveal reveal-delay-1 flex flex-col gap-4">
          {FEATURES.map((feature, index) => (
            <div
              key={feature.key}
              className="flex items-center gap-5 rounded-lg border border-background-200 bg-background-50 px-6 py-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100/70 text-primary-600">
                <i className={`${feature.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="text-base font-medium text-foreground-900 md:text-lg">
                {t(feature.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}